<template>
	<div :class="classNames+ '_wrap'">
		<div :class="classNames+ '_headtool'">
			  <el-button @click="setTab(index + 1)" :type="tabIndex == (index+1) ? 'primary' : ''" v-for="(item,index) of tabList" :key="item.value">{{item.label}}</el-button>
		</div>
		<!-- 快捷回复 -->
		<fastList :tabindex="tabIndex" v-if="tabIndex == 1"></fastList>
		<!-- 自动回复 -->
		<autoList :tabindex="tabIndex" v-if="tabIndex == 2"></autoList>
	</div>
</template>
<script>
	
import useTable from '@/components/useTable/useTable.vue'
import { mapActions } from 'vuex'
import fastList from './fastList.vue'
import autoList from './autoList.vue'
export default {
	data() {
		return {
			classNames: 'replyList',
			tabIndex: 1,
			tabList: [
				{
					label: '快捷回复',
					value: 1
				},
				
				{
					label: '自动回复',
					value: 2
				}
			]
		}
	},
	
	components: {
		fastList,
		autoList
	},
	methods: {
		setTab(data) {
			this.tabIndex = data
		}
	}
}
</script>
<style lang="less" scoped>
	 @classNames: replyList;
	 .@{classNames}_headtool{
		 margin-bottom: 20px;
	 }
</style>

